import * as JawCrusherCJConfig from 'unitData/Crushers/CrusherJawCJ/CrusherJawCJTypes';
import jawCrusherCJ from './jawCrusherCJ.png';
import jawCrusherCJ_rounded from './jawCrusherCJ_rounded.png';
import JawCrusherBW from '../../Generic/GenericCrusher/images/JawCrusherBW.png';
import jawCrusherCJ2 from './jawCrusherCJ_2.png';

export const getImageJawCrusherCJ = (
  modelName: string,
  showCustomModel: boolean | undefined,
) => {
  if (showCustomModel) {
    return JawCrusherBW;
  } else if (modelName === JawCrusherCJConfig.CrusherJawTypes.CJ211) {
    return jawCrusherCJ_rounded;
  } else {
    return jawCrusherCJ;
  }
};

export const getImageJawCrusherCJ2 = (
  modelName: string,
  showCustomModel: boolean,
) => {
  if (showCustomModel) {
    return JawCrusherBW;
  } else if (modelName === JawCrusherCJConfig.CrusherJawTypes.CJ211) {
    return jawCrusherCJ_rounded;
  } else {
    return jawCrusherCJ2;
  }
};
